import { GzIsolateEndpointTaskWebComponent } from './component/GzIsolateEndpointTaskWebComponent';

export { GzIsolateEndpointTaskWebComponent };
